import { useTranslations } from "next-intl";
import { OmnibusLowestPrice } from "@/features/diets/components/omnibus-lowest-price";
import { getOmnibusPresentation } from "@/features/diets/helpers/omnibus";
import { getLocalePrice } from "@/lib/utilities";
import { cn } from "@/lib/utils";

// "Od X zł / dzień" of a diet card under the Omnibus flag (MPL-1835). The sale
// price is the listing's promoPrice; it is styled as a reduction, next to the
// struck-through regular price and L, only when L is above it. Otherwise only
// the sale price is shown (contract pt 7).
export const DietListItemOmnibusPrice = ({
  price,
  promoPrice,
  lowestPrice,
  className,
}: {
  // Regular price per day.
  price: number;
  promoPrice?: number | null;
  lowestPrice?: number | null;
  className?: string;
}) => {
  const t = useTranslations();
  const salePrice = promoPrice ?? price;
  const omnibus = getOmnibusPresentation({ price: salePrice, lowestPrice });

  return (
    <div className={cn("flex flex-col gap-0.5", className)}>
      <p className="flex flex-wrap items-baseline gap-1 whitespace-nowrap">
        <span
          className={cn(
            "font-medium text-xl leading-7",
            omnibus.promotion ? "text-text-discount" : "text-text",
          )}
        >
          {t("diets.price_from_amount", {
            price: getLocalePrice({ price: salePrice }),
          })}
        </span>
        {omnibus.promotion && price > salePrice && (
          <span className="text-base text-text-subtle leading-6 line-through">
            {getLocalePrice({ price })}
          </span>
        )}
        <span className="text-base text-text leading-6">{`/ ${t("diets.day")}`}</span>
      </p>
      {omnibus.promotion && (
        <OmnibusLowestPrice lowestPrice={omnibus.lowestPrice} />
      )}
    </div>
  );
};
